/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'svg'>

export const Leaf: React.FC<Props> = ({ fill = 'currentColor', height = '1em', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fillRule="evenodd"
		clipRule="evenodd"
		width={height}
		height={height}
		fill={fill}
		{...props}
		viewBox="0 0 16 16"
	>
		<path d="M2.51 8.77a3.7 3.7 0 0 0 2.17.66c.5 0 1.07-.1 1.68-.28.36.38.63.84.79 1.33 0 1.08.35 3.62.37 3.66a.29.29 0 0 0 .53-.22c0-.03-.66-3.31-.07-4.95.78.24 1.5.36 2.16.36 1.04 0 1.97-.28 2.76-.84C15.83 6.45 16 1.43 16 1.22a.29.29 0 0 0-.31-.3c-3.59.3-6.06 1.39-7.36 3.25a5.7 5.7 0 0 0-.84 4.46c-.1.24-.17.49-.23.74a4.2 4.2 0 0 0-.46-.6c.1-.45.33-1.99-.67-3.42C5.1 3.89 3.19 3.05.4 2.82a.29.29 0 0 0-.31.3c0 .16.13 4.06 2.41 5.65ZM14.87 2.1a.3.3 0 0 1-.15.4 12.9 12.9 0 0 0-5.88 5.45.3.3 0 1 1-.52-.29 13.49 13.49 0 0 1 6.15-5.71.3.3 0 0 1 .4.15ZM6.18 8.4a.3.3 0 0 0 .5-.33 12 12 0 0 0-4.85-4.4.3.3 0 0 0-.25.54 11.4 11.4 0 0 1 4.6 4.2Z" />
	</svg>
)
